import { Box, Button, HStack, Text } from "@chakra-ui/react";
import { navigate } from "gatsby";
import React from "react";
import { FiUserCheck } from "../../customIcons";

const SignInBannerBlogSection = () => {
  return (
    <HStack
      borderRadius="8px"
      w="100%"
      py="24px"
      h={{ base: "400px", md: "145px" }}
      bg="#F3EBFF"
      alignItems="center"
      mx="auto"
      justifyContent="space-between"
      px="24px"
    >
      <Box lineHeight="36px" alignItems="flex-start" w="100%">
        <Text as="span" fontSize="28px" color="#3B2060">
          Ready to Buy?{" "}
        </Text>
        <Text fontSize="28px" color="#3B2060 !important">
          {" "}
          <Text color="#BB5D82" fontWeight="700" as="span">
            Sign in{" "}
          </Text>
          to Find the Best Option
        </Text>
      </Box>
      <Box flex={1} pr={{ base: "0px", md: "24px" }} w="100%">
        <Button
          onClick={() => navigate("/sign-in/")}
          leftIcon={<FiUserCheck width="16px" height="16px" />}
          borderRadius="6px"
          w="144px"
          h="48px"
          bg="#522C85"
          color="#fff"
          fontSize="20px"
          _hover={{ bg: "#6A3AAB" }}
          fontWeight="600"
        >
          Sign In
        </Button>
      </Box>
    </HStack>
  );
};

export default SignInBannerBlogSection;
